var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPCoolingChillerEv = function SvgPCoolingChillerEv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684.2 480.2",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684.2 480.2"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 46.1,
    y1: 202.1,
    x2: 46.1,
    y2: 174.1,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.1,
    y1: 188.1,
    x2: 46.1,
    y2: 188.1,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "39,201.6 46.1,189.1 53.2,201.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1,190.1l6.3,11H39.8L46.1,190.1 M46.1,188.1l-8,14h16L46.1,188.1L46.1,188.1L46.1,188.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "39,174.6 53.2,174.6 46.1,187.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8,175.1h12.5l-6.3,11L39.8,175.1 M38.1,174.1l8,14l8-14H38.1L38.1,174.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M67.1,198.6c-5.8,0-10.5-4.7-10.5-10.5s4.7-10.5,10.5-10.5s10.5,4.7,10.5,10.5S72.9,198.6,67.1,198.6z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1,178.1c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S61.6,178.1,67.1,178.1 M67.1,177.1c-6.1,0-11,4.9-11,11 s4.9,11,11,11s11-4.9,11-11S73.2,177.1,67.1,177.1L67.1,177.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66,185.2l1.6,4.4l1.6-4.4h1.3v5.7h-1V189l0.1-2.5l-1.7,4.4h-0.7l-1.7-4.4l0.1,2.5v1.9h-1v-5.7H66L66,185.2z"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 56.1,
    y1: 216.1,
    x2: 50.6,
    y2: 216.1,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 38.6,
    y: 202.6,
    width: 15,
    height: 3,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1,203.1v2h-14v-2H53.1 M54.1,202.1h-16v4h16V202.1L54.1,202.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 38.6,
    y: 226.6,
    width: 15,
    height: 3,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1,227.1v2h-14v-2H53.1 M54.1,226.1h-16v4h16V226.1L54.1,226.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 41.6,
    y: 205.6,
    width: 9,
    height: 21,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1,206.1v20h-8v-20H50.1 M51.1,205.1h-10v22h10V205.1L51.1,205.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.7,226.1c-1.8-2.6-2.8-6.4-2.8-9.9s1-7.3,2.8-9.9",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6,226.1c1.8-2.6,2.8-6.4,2.8-9.9s-1-7.3-2.8-9.9",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 56.6,
    y: 205.6,
    width: 21,
    height: 21,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1,206.1v20h-20v-20H77.1 M78.1,205.1h-22v22h22V205.1L78.1,205.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.5,213.1h1.1l-2,5.7h-1l-2.1-5.7h1.1l1.4,4.4C67.1,217.6,68.5,213.1,68.5,213.1z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.1,
    y1: 205.1,
    x2: 67.1,
    y2: 199.1,
    fill: "none",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 72.1,
    y1: 237.1,
    x2: 72.1,
    y2: 231.6,
    fill: "none",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.6,232.6 72.1,227.1 70.7,232.6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 62.1,
    y1: 237.1,
    x2: 62.1,
    y2: 231.6,
    fill: "none",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.5,232.6 62.1,227.1 60.7,232.6"
  })))));
};
export default SvgPCoolingChillerEv;